"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _CatalogueCategoryCarousel = _interopRequireDefault(require("../../../components/CatalogueCategoryCarousel"));

//
var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {}
    }
  );
}, {
  name: 'CatalogueSubCategories'
});

function CatalogueSubCategories(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      subCategories = _ref.subCategories,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "subCategories"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  return subCategories && subCategories.length > 0 ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_CatalogueCategoryCarousel.default, {
    title: t('subCategories/title'),
    categories: subCategories
  })) : null;
}

process.env.NODE_ENV !== "production" ? CatalogueSubCategories.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  subCategories: _propTypes.default.arrayOf(_propTypes.default.shape({}))
} : void 0;
CatalogueSubCategories.defaultProps = {
  classes: undefined,
  className: undefined,
  subCategories: undefined
};
var _default = CatalogueSubCategories;
exports.default = _default;